export var EventName;
(function (EventName) {
    EventName["LEGACY_EVENT"] = "legacyEvent";
    EventName["EXPERIMENT_EVENT"] = "experimentEvent";
    EventName["FILTER_INTERACTION"] = "filterInteraction";
})(EventName || (EventName = {}));
